import { render, staticRenderFns } from "./admin_unit_module_activity.vue?vue&type=template&id=438edd82&"
import script from "./admin_unit_module_activity.vue?vue&type=script&lang=js&"
export * from "./admin_unit_module_activity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports